import { staffCommandOutcomeSchema, staffPaymentQuoteListSchema, staffPaymentRequestViewSchema, staffSupersedeQuoteResultSchema, } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
const requestPath = (requestId) => `/staff/concierge-requests/${encodeURIComponent(requestId)}/quotes`;
const quotePath = (quoteId) => `/staff/payment-quotes/${encodeURIComponent(quoteId)}`;
export function createStaffQuotesApi(options) {
    const send = createMemoryTransport(options);
    return {
        list: (requestId, callOptions) => send({
            method: "GET",
            path: requestPath(requestId),
            schema: staffPaymentQuoteListSchema,
            signal: callOptions?.signal,
        }),
        record: (requestId, input, o) => send({
            method: "POST",
            path: requestPath(requestId),
            body: input,
            schema: staffCommandOutcomeSchema,
            idempotencyKey: o?.idempotencyKey,
            signal: o?.signal,
        }),
        supersede: (quoteId, input, o) => send({
            method: "POST",
            path: `${quotePath(quoteId)}/supersede`,
            body: input,
            schema: staffSupersedeQuoteResultSchema,
            idempotencyKey: o?.idempotencyKey,
            signal: o?.signal,
        }),
        issuePayment: (quoteId, input, o) => send({
            method: "POST",
            path: `${quotePath(quoteId)}/payment-requests`,
            body: input ?? {},
            schema: staffPaymentRequestViewSchema,
            idempotencyKey: o?.idempotencyKey,
            signal: o?.signal,
        }),
    };
}
